import React from 'react';
import { useSelector } from 'react-redux';

const ContributionInfo = ({details, payPeriodsUntilEffectiveDate, remainingPayChecksThisYear}) => {
    const enrollments = useSelector(s => s.enrollments);

    return (
        <>
        <table className="table-auto border-collapse border border-slate-300 max-w-lg">
             <tbody>
                  <tr>
                       <td className='border border-slate-600 p-2'>IRS Contribution Limit</td>
                       <td className='border border-slate-600 p-2'>${details.yearlyMax.toLocaleString()}</td>
                  </tr>
                  {details.yearToDateContributionAmount > 0 ?
                  <tr>
                       <td className='border border-slate-300 p-2'>{new Date(enrollments.effectiveDate).getFullYear()} YTD Contributions at Clayco</td>
                       <td className='border border-slate-300 p-2'>
                            ${details.yearToDateContributionAmount.toLocaleString()}
                       </td>
                  </tr>
                  : <></>}
                  {details.payPeriodsUntilEffectiveDate === 0 || details.currentWeeklyContributions === 0 ?
                  <></>
                  :
                  <>
                  <tr>
                       <td className='border border-slate-300 p-2'>Pay Periods Until Effective Date</td>
                       <td className='border border-slate-300 p-2'>
                            {payPeriodsUntilEffectiveDate}
                       </td>
                  </tr>
                  <tr>
                       <td className='border border-slate-300 p-2'>Weekly Contribution Amount</td>
                       <td className='border border-slate-300 p-2'>
                            ${details.currentWeeklyContributions ? details.currentWeeklyContributions?.toLocaleString() : 0}
                       </td>
                  </tr>
                  </>
                  
                  }
                  {(details.currentWeeklyContributions * payPeriodsUntilEffectiveDate + details.yearToDateContributionAmount) !== 0 && details.payPeriodsUntilEffectiveDate > 0 ?
                  <tr>
                       <td className='border border-slate-300 p-2'>{new Date(enrollments.effectiveDate).getFullYear()} YTD Contributions before Effective Date</td>
                       <td className='border border-slate-300 p-2'>
                            ${
                                 (details.currentWeeklyContributions * payPeriodsUntilEffectiveDate + details.yearToDateContributionAmount).toLocaleString()
                            }
                       </td>
                  </tr>
                  : <></> }
                  <tr>
                       <td className='border border-slate-300 p-2'>
                            *{new Date(enrollments.effectiveDate).getFullYear()} Avaiable Contribution Amount <br />
                       </td>
                       <td className='border border-slate-300 p-2'>
                            ${details.myYearlyMax?.toLocaleString()}
                       </td>
                  </tr>
                  <tr>
                       <td className='border border-slate-300 p-2'>Remaining Pay Periods in {new Date(enrollments.effectiveDate).getFullYear()} after Effective Date</td>
                       <td className='border border-slate-300 p-2'>
                            {remainingPayChecksThisYear}
                       </td>
                  </tr>
                  <tr>
                       <td className='border border-slate-300 p-2'>*Available Contribution Amount spread across remaining weeks</td>
                       <td className='border border-slate-300 p-2'>
                            ${details.myWeeklyMax?.toLocaleString()}
                       </td>
                  </tr>
             </tbody>
        </table>
        </>
   );}
 
export default ContributionInfo;